var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttrNameCasing = exports.TagNameCasing = void 0;
var TagNameCasing;
(function (TagNameCasing) {
    TagNameCasing[TagNameCasing["Kebab"] = 0] = "Kebab";
    TagNameCasing[TagNameCasing["Pascal"] = 1] = "Pascal";
})(TagNameCasing = exports.TagNameCasing || (exports.TagNameCasing = {}));
var AttrNameCasing;
(function (AttrNameCasing) {
    AttrNameCasing[AttrNameCasing["Kebab"] = 0] = "Kebab";
    AttrNameCasing[AttrNameCasing["Camel"] = 1] = "Camel";
})(AttrNameCasing = exports.AttrNameCasing || (exports.AttrNameCasing = {}));
// only export types of depend packages
__exportStar(require("@volar/vue-language-core/out/types"), exports);
//# sourceMappingURL=types.js.map